import React from 'react';
import PropTypes from 'prop-types';
import { useTooltip } from '../../hooks';
import styles from '../../styles/views/components/InputComponent.module.scss';

const InputComponent = React.forwardRef(({
  className,
  labelType,
  type,
  isDisabled,
  name,
  label,
  placeholder,
  onChange,
  error,
  extraStyles,
  classes,
  icon,
  refs,
  value,
  maxLength,
  showCounter,
  labelTooltip,
  ...inputProps
}, ref) => {
  useTooltip();

  const toggleShowHide = (e) => {
    if (e.target.previousElementSibling.type === 'password') {
      e.target.previousElementSibling.type = 'text';
      e.target.className = styles.hidePassIcon;
    } else {
      e.target.previousElementSibling.type = 'password';
      e.target.className = styles.showPassIcon;
    }
  };

  const labelClassName = labelType === 'compact'
    ? (error ? styles.compactErrorLabel : styles.compactLabel)
    : styles.label;

  return (
    <div style={extraStyles} className={className}>
      <div className={styles.wrapper}>
        {label
          && (
          <label
            className={[labelClassName, isDisabled ? styles.disabledLabel : '', classes.label].join(' ')}
            htmlFor={name}
            data-tip={labelTooltip}
          >
              {label}
          </label>
          )}
        <input
          ref={(node) => {
            refs.push(node);
            return ref;
          }}
          id={name}
          name={name}
          disabled={isDisabled}
          type={type}
          className={error ? styles.errorField : (type === 'password' ? styles.passwordField : (type === 'search' ? styles.searchField : styles.field))}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          maxLength={maxLength}
          {...inputProps}
        />
        {showCounter && (
          <span className={styles.counter}>{value ? value.length : 0}/{maxLength}</span>
        )}
        {icon && icon}
        {type === 'password' && <i className={styles.showPassIcon} onClick={toggleShowHide} />}
        {type === 'search' && <i className={styles.searchIcon} />}
        {error && (
          <span className={styles.errorLabel}>
            {error}
          </span>
        )}
      </div>
    </div>
  );
});

InputComponent.propTypes = {
  className: PropTypes.string,
  extraStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  labelType: PropTypes.oneOf(['compact', 'classic']),
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  isDisabled: PropTypes.bool,
  classes: PropTypes.shape({
    label: PropTypes.string,
  }),
  icon: PropTypes.node,
  refs: PropTypes.array,
  showCounter: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLength: PropTypes.number,
  labelTooltip: PropTypes.string,
};

InputComponent.defaultProps = {
  className: '',
  labelType: 'compact',
  extraStyles: null,
  type: 'text',
  placeholder: 'Type here',
  isDisabled: false,
  onChange: () => {},
  label: '',
  error: '',
  classes: {},
  icon: null,
  refs: [],
  showCounter: false,
  value: undefined,
  maxLength: -1,
  labelTooltip: '',
};

export default InputComponent;
